function initPage1(vm, self) {
	vm.provinceForeignAddressPO = "";
	vm.provinceMainLA = "";
	vm.provincesubLA = "";
	vm.districtForeignAddressPO = "";
	vm.districtMainLA = "";
	vm.districtsubLA = "";

	vm.listEducation = [];

	vm.listNationality = [];

	vm.listPhoneCode = [];

	vm.listDistrictForeign = [];
	vm.listDistrictForeignPersonal = [];
	vm.listDistrictVN = [];
	vm.listDistrictMainLA = [];
	vm.listDistrictSubLA = [];

	vm.listWardForeign = [];
	vm.listWardForeignPersonal = [];
	vm.listWardVN = [];
	vm.listWardMainLA = [];
	vm.listWardSubLA = [];

	vm.getOccupation();
	vm.getNationality();
	vm.getProvince();
	vm.getListEducation();
	vm.getBanks();
	// vm.getPhoneCode();

	vm.invalidTab1 = function() {
		self.clearMessage();
		if (vm.proposal !== undefined
				&& vm.proposal.proposalNum !== undefined
				&& (vm.proposal.proposalNum === null || vm.proposal.proposalNum === '')) {
			self.addAlert('Chưa nhập Hồ sơ số.', 'danger');
			return true;
		}
		var hasError = false;
		if (vm.proposal !== undefined ) {
			if (vm.proposal !== undefined && !vm.proposal.checkAllDisable) {
				for (var i = 0; i < vm.checkIDNum.length; i++) {
					if (vm.checkIDNum[i] == -1) {
						if (i == 0) {
							if (vm.proposal.po.poType == 'P') {
								if (vm.proposal.po.customer.idNum !== null
										&& vm.proposal.po.customer.idNum !== '') {
									var name = '';
									if (vm.proposal.po.customer.lastName !== null
											&& vm.proposal.po.customer.lastName !== '')
										name = vm.proposal.po.customer.lastName
												+ ' ';
									if (vm.proposal.po.customer.firstName !== null
											&& vm.proposal.po.customer.firstName !== '')
										name = vm.proposal.po.customer.firstName;
									if (name != undefined && name != null
											&& name != '') {
										self.addAlert("CMND/Khai sinh số khách hàng ["
												+ name + "] chưa được kiểm tra.",
												'danger');
									} else {
										self
												.addAlert(
														'Vui lòng nhập họ và tên bên mua bảo hiểm.',
														'danger');
									}
									hasError = true;
								}
							}else if (vm.proposal.po.poType == 'C'){
								if (vm.proposal.po.customer.idNum !== null
										&& vm.proposal.po.customer.idNum !== '') {
									var name = '';
									if (vm.proposal.po.customer.companyName !== null
											&& vm.proposal.po.customer.companyName !== '')
										name = vm.proposal.po.customer.companyName;
									if (name != undefined && name != null && name != '') {
										self.addAlert("Thông tin khách hàng [" + name
												+ "] chưa được kiểm tra.", 'danger');
									}
									hasError = true;
								}
								if (!hasError && vm.proposal !== undefined) {
									if (vm.proposal.po.customer.companyName === null || vm.proposal.po.customer.companyName === undefined 
											|| vm.proposal.po.customer.companyName === '') {
										self.addAlert('Vui lòng nhập tên doanh nghiệp.', 'danger');
										hasError = true;
									}
									if (vm.proposal.po.customer.corporateFao === null || vm.proposal.po.customer.corporateFao === undefined 
											|| vm.proposal.po.customer.corporateFao === '') { 
										self.addAlert('Vui lòng nhập người đại diện.', 'danger');
										hasError = true;
									}
									if (vm.proposal.po.customer.idNum === null || vm.proposal.po.customer.idNum === '' || vm.proposal.po.customer.idNum === undefined ) {
										self.addAlert('Vui lòng nhập giấy phép KD.', 'danger');
										hasError = true;
									}
									if (vm.proposal.po.taxNumber === null || vm.proposal.po.taxNumber === undefined 
											|| vm.proposal.po.taxNumber === '') {
										self.addAlert('Vui lòng nhập MST.', 'danger');
										hasError = true;
									}
									if (vm.proposal.po.organizedType === null || vm.proposal.po.organizedType === undefined 
											|| vm.proposal.po.organizedType === '') {
										self.addAlert(
												'Vui lòng chọn loại hình tổ chức, doanh nghiệp.',
												'danger');
										hasError = true;
									}
									if (vm.proposal.po.customer.companyAddress === null  || vm.proposal.po.customer.companyAddress === undefined 
											|| vm.proposal.po.customer.companyAddress === '') {
										self.addAlert('Vui lòng nhập số nhà, đường.', 'danger');
										hasError = true;
									}
									if (vm.proposal.po.customer.residentCountryCode === null || vm.proposal.po.customer.residentCountryCode === undefined 
											|| vm.proposal.po.customer.residentCountryCode === '') {
										self.addAlert('Vui lòng chọn quốc gia.', 'danger');
										hasError = true;
									}
								}
							}
							
						} else if (i == 1) {
							if (vm.proposal.laList[0].customer !== null
									&& vm.proposal.laList[0].customer.idNum !== undefined
									&& vm.proposal.laList[0].customer.idNum !== null
									&& vm.proposal.laList[0].customer.idNum !== '') {
								var name = '';
								if (vm.proposal.laList[0].customer.lastName !== null
										&& vm.proposal.laList[0].customer.lastName !== '')
									name = vm.proposal.laList[0].customer.lastName
											+ ' ';
								if (vm.proposal.laList[0].customer.firstName !== null
										&& vm.proposal.laList[0].customer.firstName !== '')
									name = vm.proposal.laList[0].customer.firstName;
								if (name != undefined && name != null
										&& name != '') {
									self.addAlert("CMND/Khai sinh số khách hàng ["
											+ name + "] chưa được kiểm tra.",
											'danger');
								} else {
									self
											.addAlert(
													'Vui lòng nhập họ và tên người bảo hiểm chính.',
													'danger');
								}
								hasError = true;
							}
						} else if (i == 2) {

							if (vm.proposal.laList[1].customer !== null
									&& vm.proposal.laList[1].customer.idNum !== undefined
									&& vm.proposal.laList[1].customer.idNum !== null
									&& vm.proposal.laList[1].customer.idNum !== '') {
								var name = '';
								if (vm.proposal.laList[1].customer.lastName !== null
										&& vm.proposal.laList[1].customer.lastName !== '')
									name = vm.proposal.laList[1].customer.lastName
											+ ' ';
								if (vm.proposal.laList[1].customer.firstName !== null
										&& vm.proposal.laList[1].customer.firstName !== '')
									name = vm.proposal.laList[1].customer.firstName;
								if (name != undefined && name != null
										&& name != '') {
									self.addAlert("CMND/Khai sinh số khách hàng ["
											+ name + "] chưa được kiểm tra.",
											'danger');
								} else {
									self
											.addAlert(
													'Vui lòng nhập họ và tên người bảo hiểm bổ sung.',
													'danger');
								}
								hasError = true;
							}
						}
					}
				}
				for (var i = 0; i < vm.checkNameAgeSexNum.length; i++) {
					if (vm.checkNameAgeSexNum[i] == -1) {
						if (i == 0) {
							if (vm.proposal.po.poType == 'P') {
								if (vm.proposal.po.customer.idNum !== null
										&& vm.proposal.po.customer.idNum !== '') {
									var name = '';
									if (vm.proposal.po.customer.lastName !== null
											&& vm.proposal.po.customer.lastName !== '')
										name = vm.proposal.po.customer.lastName
												+ ' ';
									if (vm.proposal.po.customer.firstName !== null
											&& vm.proposal.po.customer.firstName !== '')
										name = vm.proposal.po.customer.firstName;
									if (name != undefined && name != null
											&& name != '') {
										self.addAlert("Tuổi khách hàng ["
												+ name + "] chưa được kiểm tra.",
												'danger');
									} else {
										self
												.addAlert(
														'Vui lòng nhập họ và tên bên mua bảo hiểm.',
														'danger');
									}
									hasError = true;
								}
							}
							
						} else if (i == 1) {
							if (vm.proposal.laList[0].customer !== null
									&& vm.proposal.laList[0].customer.idNum !== undefined
									&& vm.proposal.laList[0].customer.idNum !== null
									&& vm.proposal.laList[0].customer.idNum !== '') {
								var name = '';
								if (vm.proposal.laList[0].customer.lastName !== null
										&& vm.proposal.laList[0].customer.lastName !== '')
									name = vm.proposal.laList[0].customer.lastName
											+ ' ';
								if (vm.proposal.laList[0].customer.firstName !== null
										&& vm.proposal.laList[0].customer.firstName !== '')
									name = vm.proposal.laList[0].customer.firstName;
								if (name != undefined && name != null
										&& name != '') {
									self.addAlert("Tuổi khách hàng ["
											+ name + "] chưa được kiểm tra.",
											'danger');
								} else {
									self
											.addAlert(
													'Vui lòng nhập họ và tên người bảo hiểm chính.',
													'danger');
								}
								hasError = true;
							}
						} else if (i == 2) {

							if (vm.proposal.laList[1].customer !== null
									&& vm.proposal.laList[1].customer.idNum !== undefined
									&& vm.proposal.laList[1].customer.idNum !== null
									&& vm.proposal.laList[1].customer.idNum !== '') {
								var name = '';
								if (vm.proposal.laList[1].customer.lastName !== null
										&& vm.proposal.laList[1].customer.lastName !== '')
									name = vm.proposal.laList[1].customer.lastName
											+ ' ';
								if (vm.proposal.laList[1].customer.firstName !== null
										&& vm.proposal.laList[1].customer.firstName !== '')
									name = vm.proposal.laList[1].customer.firstName;
								if (name != undefined && name != null
										&& name != '') {
									self.addAlert("Tuổi khách hàng ["
											+ name + "] chưa được kiểm tra.",
											'danger');
								} else {
									self
											.addAlert(
													'Vui lòng nhập họ và tên người bảo hiểm bổ sung.',
													'danger');
								}
								hasError = true;
							}
						}
					}
				}
			}
			
			if (!hasError && vm.proposal !== undefined && vm.proposal.po.poType == 'P') {
				if (vm.proposal.po.customer.lastName === null
						|| vm.proposal.po.customer.lastName === '') {
					self.addAlert(
							'Vui lòng nhập họ và tên đệm bên mua bảo hiểm.',
							'danger');
					hasError = true;
				}
				if (vm.proposal.po.customer.firstName === null
						|| vm.proposal.po.customer.firstName === '') {
					self.addAlert('Vui lòng nhập tên bên mua bảo hiểm.',
							'danger');
					hasError = true;
				}
			}
		} 
		/*else if (vm.proposal !== undefined && vm.proposal.po.poType == 'C') {
			if (vm.checkIDNum[0] == -1) {
				if (vm.proposal.po.customer.idNum !== null
						&& vm.proposal.po.customer.idNum !== '') {
					var name = '';
					if (vm.proposal.po.customer.companyName !== null
							&& vm.proposal.po.customer.companyName !== '')
						name = vm.proposal.po.customer.companyName;
					if (name != undefined && name != null && name != '') {
						self.addAlert("Thông tin khách hàng [" + name
								+ "] chưa được kiểm tra.", 'danger');
					}
					hasError = true;
				}
			}
			if (!hasError && vm.proposal !== undefined) {
				if (vm.proposal.po.customer.companyName === null || vm.proposal.po.customer.companyName === undefined 
						|| vm.proposal.po.customer.companyName === '') {
					self.addAlert('Vui lòng nhập tên doanh nghiệp.', 'danger');
					hasError = true;
				}
				if (vm.proposal.po.customer.corporateFao === null || vm.proposal.po.customer.corporateFao === undefined 
						|| vm.proposal.po.customer.corporateFao === '') { 
					self.addAlert('Vui lòng nhập người đại diện.', 'danger');
					hasError = true;
				}
				if (vm.proposal.po.customer.idNum === null || vm.proposal.po.customer.idNum === '' || vm.proposal.po.customer.idNum === undefined ) {
					self.addAlert('Vui lòng nhập giấy phép KD.', 'danger');
					hasError = true;
				}
				if (vm.proposal.po.taxNumber === null || vm.proposal.po.taxNumber === undefined 
						|| vm.proposal.po.taxNumber === '') {
					self.addAlert('Vui lòng nhập MST.', 'danger');
					hasError = true;
				}
				if (vm.proposal.po.organizedType === null || vm.proposal.po.organizedType === undefined 
						|| vm.proposal.po.organizedType === '') {
					self.addAlert(
							'Vui lòng chọn loại hình tổ chức, doanh nghiệp.',
							'danger');
					hasError = true;
				}
				if (vm.proposal.po.customer.companyAddress === null  || vm.proposal.po.customer.companyAddress === undefined 
						|| vm.proposal.po.customer.companyAddress === '') {
					self.addAlert('Vui lòng nhập số nhà, đường.', 'danger');
					hasError = true;
				}
				if (vm.proposal.po.customer.residentCountryCode === null || vm.proposal.po.customer.residentCountryCode === undefined 
						|| vm.proposal.po.customer.residentCountryCode === '') {
					self.addAlert('Vui lòng chọn quốc gia.', 'danger');
					hasError = true;
				}
			}
		}*/
		if (!hasError)
			hasError = vm.validateAllRequired(false);
		return hasError;
	};
}

function setPOInfo(vm, result) {
	// vm.proposal.po.customer = result;
	angular.copy(result, vm.proposal.po.customer);
	vm.proposal.po.customer.birthCountryCode = result.birthCountryCode;
	vm.proposal.po.customer.nationality = result.nationality;
	vm.proposal.po.customer.dob = result.clientBirthDate;
	vm.calculaNumberYear(vm.proposal.receiptDate, vm.proposal.po.customer.dob,
			1);
	vm.proposal.po.customer.locationCode = result.locationCode;
	vm.proposal.po.customer.residentCountryCode = result.residentCountryCode;
	vm.proposal.po.taxNumber = result.clientTaxCode;
	vm.proposal.po.customer.corporateFao = result.corporateFao;
	vm.proposal.po.organizedType = result.organizationTypeCode;
	vm.proposal.po.customer.companyName = result.lastName;
	vm.proposal.po.customer.companyAddress = result.street;
	if(result.poReceivePruInfo != null && result.poReceivePruInfo != undefined && result.poReceivePruInfo !=''){
		vm.proposal.po.poReceivePruInfo = result.poReceivePruInfo;
	}else{
		vm.proposal.po.poReceivePruInfo = 'N';
	}
	
	if(result.zaloIndicator != null && result.zaloIndicator != undefined && result.zaloIndicator !=''){
		vm.proposal.po.zaloIndicator = result.zaloIndicator;
	}else{
		vm.proposal.po.zaloIndicator = '1';
	}
	vm.proposal.po.customer.taxNationality = result.taxNationality;
	
	// anc
	vm.provinceForeignAddressPO = result.provinceCode;
	vm.getDistrict(vm.provinceForeignAddressPO, 1);
	vm.getDistrict(vm.provinceForeignAddressPO, 2);
	vm.districtForeignAddressPO = result.districtCode;
	vm.getWard(vm.districtForeignAddressPO, 1);
	vm.getWard(vm.districtForeignAddressPO, 2);
	vm.getBanks();
	vm.getBranchBank();
}

function setMainLAInfo(vm, result) {
	angular.copy(result, vm.proposal.laList[0].customer);
	vm.proposal.laList[0].customer.birthCountryCode = result.birthCountryCode;
	vm.proposal.laList[0].customer.nationality = result.nationality;
	vm.proposal.laList[0].customer.dob = result.clientBirthDate;
	vm.calculaNumberYear(1, vm.proposal.laList[0].customer.dob, 2);
	vm.proposal.laList[0].customer.locationCode = result.locationCode;
	vm.proposal.laList[0].customer.residentCountryCode = result.residentCountryCode;
	// anc
	vm.provinceMainLA = result.provinceCode;
	vm.getDistrict(vm.provinceMainLA, 4);
	vm.districtMainLA = result.districtCode;
	vm.getWard(vm.districtMainLA, 4);
}

function setSubLAInfo(vm, result) {
	angular.copy(result, vm.proposal.laList[1].customer);
	vm.proposal.laList[1].customer.birthCountryCode = result.birthCountryCode;
	vm.proposal.laList[1].customer.nationality = result.nationality;
	vm.proposal.laList[1].customer.dob = result.clientBirthDate;
	vm.calculaNumberYear(1, vm.proposal.laList[1].customer.dob, 3);
	vm.proposal.laList[1].customer.locationCode = result.locationCode;
	vm.proposal.laList[1].customer.residentCountryCode = result.residentCountryCode;
	// anc
	vm.provincesubLA = result.provinceCode;
	vm.getDistrict(vm.provincesubLA, 5);
	vm.districtsubLA = result.districtCode;
	vm.getWard(vm.districtsubLA, 5);
}
